import { takeLatest, select, call, put } from "redux-saga/effects";
import axios from "../../utils/axios";
import log from "loglevel"

import getEnvParam from "../../utils/getEnvParam";
import { requestDefaultJson } from './helpers'
import { Creators as actionsConciliationResult } from '../ducks/conciliationResult'
import { downloadFile } from "../../utils/utilFile";
import messages from "../../assets/i18n";

const conciliationFromApi = (options = {}) => {
	return new Promise((resolve, reject) => {
		return axios.request(options)
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});
};

function* conciliations(payload, page, token) {
	try {
		const {
            conciliacao,
            pedido,
            nomeFornecedor,
            dataConciliacaoInicial,
            dataConciliacaoFinal,
            statusComercial,
            statusRFM,
            notaFiscal,
            orderBy
        } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CONCILIACAO_COMERCIAL"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query 
            {
                buscarConciliacoesParaListagem(
                    conciliacao: "${conciliacao ? `${conciliacao}` : ''}"
                    pedido: "${pedido ? `${pedido}` : ''}"
                    nomeFornecedor: "${nomeFornecedor ? `${nomeFornecedor}` : ''}"
                    dataConciliacaoInicial: "${dataConciliacaoInicial ? `${dataConciliacaoInicial}` : ''}"
                    dataConciliacaoFinal: "${dataConciliacaoFinal ? `${dataConciliacaoFinal}` : ''}"
                    statusComercial: "${statusComercial ? `${statusComercial}` : ''}"
                    statusRFM: "${statusRFM ? `${statusRFM}` : ''}"
                    notaFiscal: "${notaFiscal ? `${notaFiscal}` : ''}"
                    pagina: ${page}
                    max: 20
                    orderBy: "${orderBy ? orderBy : ""}"
                ) {
                    conciliacao
                    pedido
                    codigoFornecedor
                    nomeFornecedor
                    dataConciliacao
                    motivoReprovacao
                    statusComercial
                    statusRFM
                    notaFiscal
                    serieNotaFiscal
                }
            }`
		};

		const { data } = yield call(conciliationFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* cancel(payload, token) {
	try {
		const { order, motivoCancelamento } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CONCILIACAO_COMERCIAL"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`mutation {
                cancelarConciliacao(orderId: "${order.id}", motivoCancelamento: "${motivoCancelamento}") {
                    id
                }
            }`
		};

		const { data } = yield call(conciliationFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* observacao(payload, token) {
	try {
		const { order, observacao } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CONCILIACAO_COMERCIAL"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
            mutation {
                salvarObservacao(                
                observacaoConciliacaoInputDTO: {                
                    orderId: "${order.id}"
                    observacao: "${observacao}"
                }) {
                    id
                }
            }`
		};

		const { data } = yield call(conciliationFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

const getConciliationResult = (orderId = {}, token) => {
    return new Promise((resolve, reject) => {
        return axios.request({
            method: "POST",
            headers: {
                "Content-Type": "application/graphql",
                "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CONCILIACAO_COMERCIAL"),
                "Authorization": token
            },
            data: `{
                buscarResultadoConciliacaoPorPedido(pedido: "${orderId}") {
                    id
                    pedido {
                        id
                        fornecedor {
                            nome
                        }
                    }
                    statusConciliacaoComercial {
                        id
                    }
                    statusConciliacaoFiscal {
                        id
                    }
                    notaFiscal
                    motivoReprovacao
                    observacao
                    conciliacaoItems {
                        item {
                            codItem
                            detalheItems {
                                descricaoCurta
                            }
                        }
                        motivoReprovacao
                        ean
                        qtItensPo
                        ncmPo
                        custoUnitarioPo
                        valorVendaPo
                        qtItensNf
                        ncmNf
                        custoUnitarioNf
                        valorVendaNf
                    }
                }
            }`
        })
            .then(response => (response.status !== 200 || !response.data) ? reject(response) : response)
            .then(response => response.data)
            .then(response => resolve(response.data.buscarResultadoConciliacaoPorPedido))
            .catch(error => {
                reject(error);
                log.info(error);
            });
    });
};

function conciliationConditionalFromApi(idConciliacao, token) {
    return requestDefaultJson({
        method: 'POST',
        URIComplete: getEnvParam('REACT_APP_BFF_URL_REST') + '/conciliacaofiscal/conciliacaoCondicional',
        headers: {
            NPF_ROUTE: getEnvParam('REACT_APP_HEADER_CONCILIACAO_FISCAL'),
            "Authorization": token,
        },
        data: {
            idConciliacao: idConciliacao,
        }
    });
}

function conciliationStatusFromApi(idConciliacao, token) {
    return requestDefaultJson({
        method: 'POST',
        URIComplete: getEnvParam('REACT_APP_BFF_URL_REST') + '/conciliacaofiscal/verificarStatusConciliacao',
        headers: {
            NPF_ROUTE: getEnvParam('REACT_APP_HEADER_CONCILIACAO_FISCAL'),
            "Authorization": token,
        },
        data: {
            idConciliacao: idConciliacao,
        }
    });
}

function getInvoiceFromApi(idConciliacao, token) {
    return requestDefaultJson({
        method: 'POST',
        URIComplete: getEnvParam('REACT_APP_BFF_URL_REST') + '/conciliacaofiscal/getXmlNota',
        headers: {
            NPF_ROUTE: getEnvParam('REACT_APP_HEADER_CONCILIACAO_FISCAL'),
            "Authorization": token,
        },
        data: {
            idConciliacao: idConciliacao,
        }
    });
}

const getHistoricoReprovacaoConciliacaoPorPedido = (orderId = {}, token) => {
    return new Promise((resolve, reject) => {
        return axios.request({
            method: "POST",
            headers: {
                "Content-Type": "application/graphql",
                "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CONCILIACAO_COMERCIAL"),
                "Authorization": token
            },
            data: `{
                buscarHistoricoReprovacaoConciliacaoPorPedido(pedido: "${orderId}") {
                    idConciliacao
                    dtConciliacaoComercial
                    motivoReprovacao
                    observacao
                }
            }`
        })
            .then(response => (response.status !== 200 || !response.data) ? reject(response) : response)
            .then(response => response.data)
            .then(response => resolve(response.data.buscarHistoricoReprovacaoConciliacaoPorPedido))
            .catch(error => {
                reject(error);
                log.info(error);
            });
    });
};

//generators
function* conciliationResult({payload}) {
    try {
		const { token } = yield select(state => state.authentication);

        yield put(actionsConciliationResult.conciliationResultLoading(true));

        const result = yield call(getConciliationResult, payload.id, token);

        if (result) {
            yield put({ type: "CONCILIATION_RESULT", payload: result});
        }
    } catch (error) {
        yield put(actionsConciliationResult.conciliationResultError(error));
        yield put({ type: "CONCILIATION_RESULT", payload: {}});

        log.info(error);
    } finally {
        yield put(actionsConciliationResult.conciliationResultLoading(false));
    }
}

function* conciliationConditional({payload}) {
    try {
        const { token } = yield select(state => state.authentication)

        yield put(actionsConciliationResult.conciliationResultLoading(true));

        const result = yield call(conciliationConditionalFromApi, payload.conciliationId, token);

        yield put({type: "TRADE_CONCILIATION",payload: true});

        yield put({ type: "TAX_CONCILIATION", payload: result});

        yield put(actionsConciliationResult.conciliationResult(payload.order.id))
    } catch (error) {
        yield put(actionsConciliationResult.conciliationResult(payload.order.id))

        log.info(error);
    } finally {
        yield put(actionsConciliationResult.conciliationResultLoading(false));
    }
}

function* getConciliationStatus({payload}) {
    try {
        console.log(payload);
        const { token } = yield select(state => state.authentication)

        yield put(actionsConciliationResult.conciliationResultLoading(true));

        yield call(conciliationStatusFromApi, payload.conciliationId, token);

        const result = yield call(getConciliationResult, payload.order.id, token);

        if (result) {
            yield put({ type: "CONCILIATION_RESULT", payload: result});
        }
    } catch (error) {
        yield put(actionsConciliationResult.conciliationResult(payload.order.id))

        log.info(error);
    } finally {
        yield put(actionsConciliationResult.conciliationResultLoading(false));
    }
}

function* getInvoice({payload}) {
    try {
        const { token } = yield select(state => state.authentication)

        yield put(actionsConciliationResult.getInvoiceLoading());

        const result = yield call(getInvoiceFromApi, payload.conciliationId, token);

        const binary = yield atob(result);

        downloadFile(binary, `nfe-pedido-${payload.order.id}.xml`, 'application/xml;charset=utf-8;');

    } catch (error) {
        yield put({
            type: "GET_TOAST",
            payload: {
                showToast: true,
                message: error.response.data,
                messageType: "toast-error"
            }});
        log.info(error);
    } finally {
        yield put(actionsConciliationResult.getInvoiceComplete());
    }
}

function* hideToast() {
    yield put({
        type: "GET_TOAST",
        payload: {
            showToast: false,
            message: '',
            messageType: "toast-error"
        }});
}

function* conciliationHistory({payload}) {
    try {
		const { token } = yield select(state => state.authentication);

        yield put(actionsConciliationResult.conciliationHistoryLoading(true));

        const result = yield call(getHistoricoReprovacaoConciliacaoPorPedido, payload.id, token);

        if (result) {
            yield put({ type: "CONCILIATION_HISTORY", payload: result});
        }
    } catch (error) {
        yield put(actionsConciliationResult.conciliationHistoryError(error));

        log.info(error);
    } finally {
        yield put(actionsConciliationResult.conciliationHistoryLoading(false));
    }
}

function* getConciliationList(payload) {
	try {
		const { token } = yield select(state => state.authentication);
        const nextPage = payload.page + 1;
        let result

        yield put({ type: "SET_CONCILIATION_LIST_LOADING", payload: true });

        if (payload.cleanTable) {
            yield put({ type: "CLEAN_CONCILIATION_LIST" });
        }

		result = yield call(conciliations, payload.filter, payload.page, token);

		if (result) {
            if (result.buscarConciliacoesParaListagem && result.buscarConciliacoesParaListagem.length) {
                yield put({
                    type: "SET_CONCILIATION_LIST",
                    payload: {
                        list: result.buscarConciliacoesParaListagem,
                        hasMore: true,
                        page: nextPage,
                    }
                });
            } else {
                yield put({
                    type: "SET_CONCILIATION_LIST",
                    payload: {
                        list: result.buscarConciliacoesParaListagem,
                        hasMore: false,
                        page: payload.page,
                    }
                });
            }
        }

        yield put({ type: "SET_CONCILIATION_LIST_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* cancelConciliation(payload) {
	try {
        const lang = yield select(state => state.language.name);
        const { token } = yield select(state => state.authentication);

		let result = yield call(cancel, payload.payload, token);

        if (result && result.cancelarConciliacao) {
            yield put({
                type: "SET_MODAL_CONFIRM_CANCEL",
                payload: {
                    show: false
            }});

            yield put({
                type: "SET_RELOAD_CONCILIATION_RESULT_PAGE",
                payload: {
                    reload: true
            }});

            yield put({
                type: "GET_TOAST",
                payload: {
                    showToast: true,
                    message: messages[lang].successCancelConciliation,
                    messageType: "toast-success"
            }});
        }
	} catch (error) {
        yield put({
            type: "GET_TOAST",
            payload: {
                showToast: true,
                message: error.response.data,
                messageType: "toast-error"
        }});
		log.info(error);
	}
}

function* salvarObservacao(payload) {
	try {
        const lang = yield select(state => state.language.name);
        const { token } = yield select(state => state.authentication);

		let result = yield call(observacao, payload.payload, token);

        if (result && result.salvarObservacao) {
            console.log(result)
            yield put({
                type: "SET_MODAL_OBSERVACAO",
                payload: {
                    show: false
            }});

            yield put({
                type: "SET_RELOAD_CONCILIATION_RESULT_PAGE",
                payload: {
                    reload: true
            }});

            yield put({
                type: "GET_TOAST",
                payload: {
                    showToast: true,
                    message: messages[lang].conciliationHistoryListPage.observacaoSalva,
                    messageType: "toast-success"
            }});
        }
	} catch (error) {
        yield put({
            type: "GET_TOAST",
            payload: {
                showToast: true,
                message: error.response.data,
                messageType: "toast-error"
        }});
		log.info(error);
	}
}

// //Generator function
export function* conciliationResultWatcher() {
    yield takeLatest("GET_CONCILIATION_RESULT", conciliationResult);
    yield takeLatest("GET_CONCILIATION_CONDITIONAL", conciliationConditional);
    yield takeLatest("GET_CONCILIATION_STATUS", getConciliationStatus);
    yield takeLatest("GET_INVOICE", getInvoice);
    yield takeLatest("HIDE_TOAST", hideToast);
    yield takeLatest("GET_CONCILIATION_HISTORY", conciliationHistory);
    yield takeLatest("GET_CONCILIATION_LIST", getConciliationList);
    yield takeLatest("CANCEL_CONCILIATION", cancelConciliation);
    yield takeLatest("SALVAR_OBSERVACAO", salvarObservacao);
}
